import { memo, useId } from "react";

export const AutomationStepArrow = memo(({ className }: { className?: string }) => {
    const id = useId();
    const gradId = `${id}-g`;

    return (
        <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Next step</title>
            <defs>
                <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stopColor="currentColor" stopOpacity="0" />
                    <stop offset="0.3" stopColor="currentColor" stopOpacity="0.25" />
                    <stop offset="0.5" stopColor="currentColor" stopOpacity="0.65" />
                    <stop offset="0.7" stopColor="currentColor" stopOpacity="0.25" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
            {/* Horizontal gradient bar */}
            <rect x="0" y="0" width="24" height="1" fill={`url(#${gradId})`} />
            {/* Vertical stem + arrowhead */}
            <path
                d="M11.5 0L11.5 35L12.5 35L12.5 0L11.5 0ZM11.6464 35.3536C11.8417 35.5488 12.1583 35.5488 12.3536 35.3536L15.5355 32.1716C15.7308 31.9763 15.7308 31.6597 15.5355 31.4645C15.3403 31.2692 15.0237 31.2692 14.8284 31.4645L12 34.2929L9.17157 31.4645C8.97631 31.2692 8.65973 31.2692 8.46447 31.4645C8.2692 31.6597 8.2692 31.9763 8.46447 32.1716L11.6464 35.3536Z"
                fill="currentColor"
            />
        </svg>
    );
});
AutomationStepArrow.displayName = "AutomationStepArrow";
